import { render } from "./LastReceived.vue?vue&type=template&id=1d50caa7"
import script from "./LastReceived.vue?vue&type=script&lang=js"
export * from "./LastReceived.vue?vue&type=script&lang=js"

import "./LastReceived.vue?vue&type=style&index=0&id=1d50caa7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__